import { eventListenerOptions } from '../event-listener-options';

/**
 * Should not be referenced directly.
 *
 * @param {HTMLElement} el
 *
 * @private
 * @see {@link objectFit}
 */
export function initObjectFit(el) {
    let objectFitContainer;

    if (!el || !el.length) {
        objectFitContainer = document.querySelectorAll('.object-fit');
    } else {
        objectFitContainer = el.querySelectorAll('.object-fit');
    }

    const objectFitFromImg = (container, img) => {
        let imgUrl = img.src,
            imgUrlAsync = img.getAttribute('data-src'),
            objectfitFallbackUrl = img.getAttribute('data-objectfit');

        if (imgUrlAsync) {
            imgUrl = imgUrlAsync;
        }

        if (objectfitFallbackUrl) {
            imgUrl = objectfitFallbackUrl;
        }

        if (imgUrl) {
            container.style.backgroundImage = `url(${imgUrl})`;
            container.classList.add('compat-object-fit');
        }
    };

    objectFitContainer.forEach(container => {
        let img = container.querySelector('img');

        if (!img) {
            return;
        }

        img.addEventListener('load', objectFitFromImg(container, img), eventListenerOptions({ passive: true }));

        // if the image was faster than the script, trigger the loading event manually
        if (img.complete && !container.classList.contains('compat-object-fit')) {
            objectFitFromImg(container, img);
        }
    });
}
